import { useRestaurantBasePolicies } from '../api/getRestaurantBasePolicies';
import { useRestaurantTaxPolicies } from '../api/getRestaurantTaxPolicies';
import { legacyTimeslotsToPricingPolicies } from 'tdr-common';
import { TDR } from 'tdr-common';
import { estimateInvoice } from '../helpers/estimateInvoice';

interface SearchFilters {
	groupSize: number;
	date: string;
	time: string;
}

export function useEstimateInvoice(
	restaurant: Partial<TDR.Restaurant>,
	selectedTable: Partial<TDR.Table>,
	searchFilters: SearchFilters
) {
	// Always call hooks first - use enabled conditions to control when they run
	const hasRequiredData = !!(restaurant?.id && selectedTable?.id && searchFilters?.date && searchFilters?.time && searchFilters?.groupSize);
	const { data: restaurantPolicies = [] } = useRestaurantBasePolicies(restaurant?.id);
	const { data: taxPolicies = [] } = useRestaurantTaxPolicies(restaurant);

	// Early return if any required data is missing
	if (!hasRequiredData) {
		return {
			estimatedInvoice: null
		};
	}
	const tableOverridePolicies = restaurant && selectedTable ?
		legacyTimeslotsToPricingPolicies(restaurant as TDR.Restaurant, [selectedTable as TDR.Table]) :
		[];

	// Ensure all policy arrays are defined and combine them safely
	const policies = [
		...(Array.isArray(tableOverridePolicies) ? tableOverridePolicies : []),
		...(Array.isArray(restaurantPolicies) ? restaurantPolicies : []),
		...(Array.isArray(taxPolicies) ? taxPolicies : [])
	];

	// Only calculate invoice if we have the minimum required data
	const estimatedInvoice = restaurant?.id && selectedTable?.id && searchFilters ?
		estimateInvoice(policies, searchFilters, selectedTable.id, restaurant) :
		null;

	return {
		estimatedInvoice
	};
}